import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, RefreshCw, ArrowRight } from "lucide-react";
import { useFlow } from "@/flowStore";

export default function Preview() {
  const navigate = useNavigate();
  const { photo } = useFlow();

  useEffect(() => {
    if (!photo.dataUrl) navigate("/capture", { replace: true });
  }, [photo, navigate]);

  if (!photo.dataUrl) return <div style={{ minHeight: "100vh", background: "#fff" }} />;

  return (
    <div className="preview-screen" data-testid="preview-screen">
      <div className="preview-col">
        <img className="preview-photo" src={photo.dataUrl} alt="Ta participation" />
        <div className="preview-scrim" />

        <div className="preview-topbar">
          <button className="cam-icon-btn" data-testid="preview-back-button" onClick={() => navigate("/capture", { replace: true })}>
            <ChevronLeft size={22} />
          </button>
          <span className="preview-header-title">Belle photo</span>
          <div style={{ width: 40 }} />
        </div>

        <div className="preview-bottom fade-up">
          <div className="eyebrow">ÉTAPE 2 / 3</div>
          <h1 className="big-title">Ça te va ?</h1>
          <p className="subtitle">Vérifie ta photo. Tu pourras la reprendre ou continuer.</p>

          <div className="btn-row">
            <button className="btn-secondary" data-testid="retake-button" onClick={() => navigate("/capture", { replace: true })}>
              <RefreshCw size={18} />
              Reprendre
            </button>
            <button className="btn-primary" data-testid="continue-button" onClick={() => navigate("/form")}>
              Continuer
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
